import { useCallback, useMemo } from 'react'
import { ApiCore } from '../services'
import { getGaClientId, LabelClick, LandingType, trackLoginClick } from '@monorepo/service'

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
  }
}

const TOP_DOMAIN =
  typeof window !== 'undefined' ? window.location.hostname.split('.').slice(-2).join('.') : ''

interface Props {
  balancerUrl?: string
  isBalancerInfoLoading?: boolean
  balancerInfo?: ApiCore.CDALandingsResponse | null
  geo?: string
  landingType?: LandingType
}

export const useLogin = ({
  balancerUrl,
  isBalancerInfoLoading,
  balancerInfo,
  geo,
  landingType,
}: Props) => {
  const origin = useMemo(() => {
    if (!balancerUrl && isBalancerInfoLoading) return
    return (
      balancerUrl ||
      `https://${balancerInfo?.landing_to_balancer?.[TOP_DOMAIN] || balancerInfo?.balancer}/`
    )
  }, [balancerUrl, isBalancerInfoLoading, balancerInfo])

  const redirectToLoginPage = useCallback(
    (label?: LabelClick | React.MouseEvent) => {
      if (!origin) return
      const trackingLabel = typeof label === 'string' ? label : undefined

      if (landingType) trackLoginClick(landingType, trackingLabel)
      const currentParams = new URLSearchParams(window.location.search)

      currentParams.set('login', 'true')
      if (geo) currentParams.set('geo', geo)

      const gaClientId = getGaClientId()
      if (gaClientId) currentParams.set('_ga', gaClientId)

      if (typeof window.gtag === 'function') {
        window.gtag('get', window.env.APP_GA_MEASUREMENT_ID, 'session_id', (sessionId: string) => {
          if (sessionId) currentParams.set('session_id', sessionId)

          window.location.href = `${origin}?${currentParams.toString()}`
        })
      } else {
        window.location.href = `${origin}?${currentParams.toString()}`
      }
    },
    [geo, origin, landingType],
  )

  return { origin, redirectToLoginPage }
}
